import React from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
// import PropTypes from 'prop-types';

import { useDirections } from '../../utils/search';
import { getAirportNameFromDirectionsById } from '../../utils/input';

const flightSelector = (state) => state.flight;

const SearchConditionSPFlight = () => {
  const {
    flightsInput,
  } = useSelector(flightSelector);

  const directions = useDirections();

  const {
    people,
    outbound,
    inbound,
  } = flightsInput;

  const departureDate = outbound ?
    moment(outbound.date).format('YYYY年MM月DD日(ddd)') : '';
  const arrivalDate = inbound ?
    moment(inbound.date).format('YYYY年MM月DD日(ddd)') : '';
  const dateDisplay = `${departureDate} - ${arrivalDate}`;

  const outboundDepartureAirportName = getAirportNameFromDirectionsById(directions, outbound.departureAirportId);
  const outboundArrivalAirportName = getAirportNameFromDirectionsById(directions, outbound.arrivalAirportId);
  const inboundDepartureAirportName = getAirportNameFromDirectionsById(directions, inbound.departureAirportId);
  const inboundArrivalAirportName = getAirportNameFromDirectionsById(directions, inbound.arrivalAirportId);
  const airportDisplayOutbound = `${outboundDepartureAirportName} - ${outboundArrivalAirportName}`;
  const airportDisplayInbound = `${inboundDepartureAirportName} - ${inboundArrivalAirportName}`;

  const { adult, childrenA, childrenB, childrenC, children2, infant } = people;

  return (
    <div className="searchCondition">
      <div className="searchConditionTitle">選択中の検索条件</div>
      <div className="searchConditionTitleItem">
        <img className="searchConditionTitleItemIcon" src="/dp-air/img/icons/icon_calender.svg" />
        {dateDisplay}
      </div>
      <div className="searchConditionTitleItem">
        <img className="searchConditionTitleItemIcon" src="/dp-air/img/icons/icon_air.svg" />
        <div>
          <div className="searchConditionTitleItemLine">{airportDisplayOutbound}</div>
          {airportDisplayInbound}
        </div>
      </div>
      <div className="searchConditionTitleItem">
        <img className="searchConditionTitleItemIcon" src="/dp-air/img/icons/icon_people.svg" />
        <div>
          <div className="searchConditionTitleItemLine">{`大人：${adult}名`}</div>
          {!!childrenA && <div className="searchConditionTitleItemLine">{`こども(6-11歳)：${childrenA}名`}</div>}
          {!!childrenB && <div className="searchConditionTitleItemLine">{`こども(3-5歳)(寝具あり)：${childrenB}名`}</div>}
          {!!childrenC && <div className="searchConditionTitleItemLine">{`こども(3-5歳)(寝具なし)：${childrenC}名`}</div>}
          {!!children2 && <div className="searchConditionTitleItemLine">{`こども(2歳)(寝具なし)：${children2}名`}</div>}
          {!!infant && <span>{`こども(0-1歳)：${infant}名`}</span>}
        </div>
      </div>
    </div>
  );

};

SearchConditionSPFlight.propTypes = {
};

export default SearchConditionSPFlight;